import script from "./HomeWageNontaxSavingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWageNontaxSavingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWageNontaxSavingsModal.vue?vue&type=style&index=0&id=44f57a78&lang=scss"

const __exports__ = script;

export default __exports__